import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { presentTicketFactProvenance } from '@/lib/tickets/ticketFactProvenance';

/**
 * Core-100 R4 (CORE-AE / CORE-AD GAP-001) — the evidence class of ONE ticket figure, placed beside it.
 * Takes a fact group, never a class; renders nothing for an unregistered group or a class without approved copy.
 */
export function TicketProvenanceBadge({ factGroupId, className }: { factGroupId: string; className?: string }) {
  const presentation = presentTicketFactProvenance(factGroupId);
  if (!presentation) return null;
  return (
    <Badge
      variant="outline"
      className={cn('text-[10px] font-normal px-1.5 py-0 bg-primary/10 text-primary border-primary/30', className)}
      title={presentation.description}
      data-provenance-class={presentation.evidenceClass}
      data-provenance-fact={factGroupId}
    >
      {presentation.label}
    </Badge>
  );
}
